import { isDesktop } from 'react-device-detect';
import TextMetricController from '../../controllers/TextMetricController';
import BonusGameDialogueController from '../../controllers/bonus/BonusGameDialogueController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusItems } from '../splash-screen/elements/BonusItems';
import { BonusGameDialogueGridView } from './BonusGameDialogueGridView';
let scale = isDesktop ? 1 : 2;
export const BonusGameDialogueView = {
	name: COMPONENTS.BONUS_GAME_DIALOGUE,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: BonusGameDialogueController,
			name: 'BonusGameDialogueController',
			config: {
				item: 'bonus_game_dialogue_wrapper',
				val: 'bonus_game_dialogue_wrapper'
			}
		},
		{
			Controller: TextMetricController,
			name: 'TextMetricController',
			config: {
				item: 'bonus_game_dialogue_wrapper',
				val: 'bonus_game_dialogue_wrapper',
				position: { x: 0, y: 0, w: 1137 },
				texts: [
					{
						value: 'BONUS_ROUND_DIALOGUE_TEXT_4',
						position: { x: 0, y: 380 },
						maxLineWidth: 1.5,
						wordWrap: true
					}
				]
			}
		},
		{
			Controller: MainGridController,
			name: 'bonusgamegridController',
			config: BonusGameDialogueGridView
		}
	],
	components: [
		{
			name: 'bonus_game_dialogue_wrapper',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'congrats_screen',
					position: { x: 0, y: 0 },
					scale: { x: scale, y: scale }
				},
				{
					name: 'text',
					type: 'CustomText',
					text: 'BONUS_ROUND_DIALOGUE_HEADER',
					position: { x: 1137 / 2 + 10, y: 70 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'text_1',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_1',
					position: { x: 1137 / 2, y: 140 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_ROUND_DIALOGUE_TEXT_2',
					type: 'CustomText',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_2',
					position: { x: 1137 / 2 + 10, y: 255 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'text_3',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_3',
					position: { x: 1137 / 2, y: 340 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'BONUS_ROUND_DIALOGUE_TEXT_4',
					type: 'Text',
					text: 'BONUS_ROUND_DIALOGUE_TEXT_4',
					position: { x: 1137 / 2, y: 380 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'progressive_bonus',
					position: { x: 40, y: 650 },
					type: 'VisualComponent',
					component: BonusItems
				}
			]
		}
	]
};
